// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__8a4AD","description":"MealItem_description__Rhfd+","price":"MealItem_price__8G-hq"};